module.exports = __webpack_public_path__ + "static/media/bodies-2.c3293b6d.png";